import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useTranslation } from '../context/LanguageContext';

const { FiPhone, FiShield, FiAlertTriangle } = FiIcons;

const EmergencyHotlines = () => {
  const { t } = useTranslation();

  const cdrrmo = [
    { label: 'Globe', number: '0997-726-2692' },
    { label: 'Smart', number: '0969-233-7878' }
  ];

  const policeHQ = [
    { name: 'Headquarters (Globe)', number: '0917-712-7411' },
    { name: 'Headquarters (Smart)', number: '0998-598-7004' },
  ];

  const stations = [
    { name: 'Police Station 1', number: '0917-166-3440' },
    { name: 'Police Station 2', number: '0917-715-1844' },
    { name: 'Police Station 3', number: '0998-598-7010' },
    { name: 'Police Station 4', number: '0998-598-7012' },
    { name: 'Police Station 5', number: '0926-425-1015' },
    { name: 'Police Station 6', number: '0930-105-9808' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* CDRRMO */}
      <div className="bg-white rounded-[3rem] shadow-xl border border-slate-100 p-8 overflow-hidden relative group">
        <div className="relative z-10">
          <div className="flex items-center space-x-4 mb-8">
            <div className="p-3 bg-orange-50 rounded-2xl">
              <SafeIcon icon={FiAlertTriangle} className="text-2xl text-orange-600" />
            </div>
            <div>
              <h2 className="text-xl font-black text-slate-900 tracking-tight">ICDRRMO</h2>
              <p className="text-xs font-bold text-orange-500 uppercase tracking-widest">{t('disaster_response')}</p>
            </div>
          </div>
          <div className="space-y-4">
            {cdrrmo.map((item, idx) => (
              <a key={idx} href={`tel:${item.number}`} className="flex items-center justify-between p-4 bg-slate-50 hover:bg-orange-50 rounded-2xl border border-slate-100 transition-all">
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center text-slate-400 group-hover:text-orange-500">
                    <SafeIcon icon={FiPhone} />
                  </div>
                  <div>
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{item.label}</p>
                    <p className="text-lg font-bold text-slate-700 font-mono">{item.number}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
          <div className="mt-8 p-4 bg-orange-50/50 rounded-2xl border border-orange-100">
            <p className="text-[10px] text-orange-800/70 font-medium text-center leading-relaxed">{t('rescuers_info')}</p>
          </div>
        </div>
      </div>

      {/* Police Assistance */}
      <div className="bg-white rounded-[3rem] shadow-xl border border-slate-100 p-8 overflow-hidden relative group">
        <div className="relative z-10">
          <div className="flex items-center space-x-4 mb-8">
            <div className="p-3 bg-blue-50 rounded-2xl">
              <SafeIcon icon={FiShield} className="text-2xl text-blue-600" />
            </div>
            <div>
              <h2 className="text-xl font-black text-slate-900 tracking-tight">PNP Iligan</h2>
              <p className="text-xs font-bold text-blue-500 uppercase tracking-widest">{t('police_assistance')}</p>
            </div>
          </div>
          <div className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {policeHQ.map((item, idx) => (
                <a key={idx} href={`tel:${item.number}`} className="p-3 bg-blue-50/50 rounded-xl border border-blue-100 text-center">
                  <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest mb-1">{item.name}</p>
                  <p className="font-bold text-blue-900 text-sm font-mono">{item.number}</p>
                </a>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {stations.map((stn, idx) => (
                <a key={idx} href={`tel:${stn.number}`} className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100 text-xs font-bold text-slate-700 font-mono">
                  <span>{stn.name}</span>
                  <span>{stn.number}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmergencyHotlines;